import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=27ccfd96&scoped=true"
import script from "./Quantity.vue?vue&type=script&lang=js"
export * from "./Quantity.vue?vue&type=script&lang=js"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=27ccfd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ccfd96",
  null
  
)

export default component.exports